
import { HomeView } from "../views/Home";

export default HomeView;
